"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var GoogleStreetViewContext_1 = require("../context/GoogleStreetViewContext");
var GoogelStreetViewInstance_1 = require("./GoogelStreetViewInstance");
var googleStreetView = function (props) {
    var _a = React.useState(null), map = _a[0], setMap = _a[1];
    var _b = React.useState(props), mapState = _b[0], setMapState = _b[1];
    var store = { map: map, setMap: setMap, mapState: mapState, setMapState: setMapState };
    return (React.createElement(GoogleStreetViewContext_1.GoogleStreetViewContext.Provider, { value: store },
        React.createElement(GoogelStreetViewInstance_1.GoogelStreetViewInstance, __assign({}, props))));
};
exports.GoogleStreetView = googleStreetView;
